import Layout from '@/layout'

const operatorRouter = {
  path: '/operator',
  component: Layout,
  redirect: '/operator/list',
  name: 'Operator',
  meta: {
    title: '运营开通',
    icon: 'clipboard',
    roles: ['admin']
  },
  children: [
    {
      path: 'list',
      name: 'list',
      component: () => import('@/views/operator/list'),
      meta: {
        title: '运营方列表',
        icon: 'clipboard'
      }
    },
    {
      path: 'account',
      name: 'account',
      component: () => import('@/views/operator/account'),
      meta: {
        title: '运营方账户',
      }
    },
  ]
}

export default operatorRouter
